/**
 * LessonPackDetails — the ticket-shaped details block (Figma "Details block").
 *
 * Presentational only: values arrive pre-formatted. No "Purchase ID", "Total
 * Paid" or "Download Receipt" — those are BUT-841's purchase-confirmation
 * concerns, not this holdings screen's. No Status row — the card pill
 * already says it. No Remaining row, the card headline carries it.
 *
 * @module pages/lessons/components/LessonPackDetails
 */

import { TicketCard } from '@butter/ui/patterns';
import { LessonTicketRow } from './LessonTicketRow';

export interface LessonPackDetailsProps {
  /** The pack's id — drives this block's data-testids. */
  packId: number;
  purchasedLabel: string;
  /** The EFFECTIVE ceiling (`lessonPackCeilingMinutes` from `@butter/library/lessons`), not the raw template's. */
  includedLabel: string;
}

export function LessonPackDetails({
  packId,
  purchasedLabel,
  includedLabel,
}: LessonPackDetailsProps) {
  return (
    <TicketCard punched={false} borderColor="var(--theme-100)" data-testid={`lessons-pack-details-${packId}`}>
      <dl className="flex flex-col gap-4 p-7">
        <LessonTicketRow label="Purchase Date" value={purchasedLabel} />
        <LessonTicketRow label="Lesson Hours" value={includedLabel} />
      </dl>
    </TicketCard>
  );
}
